import { render } from "./Checkup.vue?vue&type=template&id=5a166538&scoped=true"
import script from "./Checkup.vue?vue&type=script&lang=js"
export * from "./Checkup.vue?vue&type=script&lang=js"

import "./Checkup.vue?vue&type=style&index=0&id=5a166538&scoped=true&lang=css"

import exportComponent from "/home/web/vina_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a166538"]])

export default __exports__